import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-br from-teal-700 to-teal-900 text-white">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              おかやま司法書士事務所
            </h3>
            <p className="text-gray-100 mb-3 md:mb-4 text-sm md:text-base leading-relaxed">
              岡山市・倉敷市を中心とした岡山県内で、司法書士業務を通じて皆様の法的手続きをサポートいたします。
            </p>
            <div className="flex space-x-4">
              <a href="tel:086-012-3456" className="text-white hover:text-teal-200 transition-colors">
                <i className="ri-phone-line text-lg md:text-xl"></i>
              </a>
              <a href="#contact" className="text-white hover:text-teal-200 transition-colors">
                <i className="ri-mail-line text-lg md:text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-base md:text-lg font-semibold mb-3 md:mb-4">サービス</h4>
            <ul className="space-y-1 md:space-y-2 text-gray-100 text-sm md:text-base">
              <li className="hover:text-white transition-colors cursor-pointer">不動産登記</li>
              <li className="hover:text-white transition-colors cursor-pointer">商業登記</li>
              <li className="hover:text-white transition-colors cursor-pointer">相続手続き</li>
              <li className="hover:text-white transition-colors cursor-pointer">債務整理</li>
              <li className="hover:text-white transition-colors cursor-pointer">成年後見</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-base md:text-lg font-semibold mb-3 md:mb-4">事務所情報</h4>
            <div className="text-gray-100 space-y-1 md:space-y-2 text-sm md:text-base">
              <p>〒700-0000</p>
              <p>岡山市北区○○町1-2-3</p>
              <p>TEL: 086-012-3456</p>
              <p>FAX: 086-012-3457</p>
              <p>営業時間: 9:00 〜 18:00</p>
              <p>定休日: 日曜日・祝日</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-teal-600 mt-6 md:mt-8 pt-6 md:pt-8 text-center text-gray-200 text-xs md:text-sm">
          <p>&copy; 2024 おかやま司法書士事務所. All rights reserved.</p>
          <p className="mt-2">
            <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
